function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import PropTypes from "prop-types";
import { keyframes } from "@emotion/core";
import { responsivePropType } from "../hooks/useResponsiveProp";
import useResponsivePropsCSS from "../hooks/useResponsivePropsCSS";
import { jsx as ___EmotionJSX } from "@emotion/core";
var SIZES = ["small", "medium", "large"];
var COLORS = ["highlight.blue.t100", "white", "black"];
var DEFAULT_PROPS = {
  size: "small",
  color: "highlight.blue.t100"
};
var circleRadiusMap = {
  small: 4,
  medium: 8,
  large: 12
};
LoadingIcon.SIZES = SIZES;
LoadingIcon.COLORS = COLORS;
LoadingIcon.DEFAULT_PROPS = DEFAULT_PROPS;

function LoadingIcon(_props) {
  var _circleRadiusMap$size;

  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);

  var size = props.size,
      testId = props.testId;
  var radius = (_circleRadiusMap$size = circleRadiusMap[size]) !== null && _circleRadiusMap$size !== void 0 ? _circleRadiusMap$size : 4;
  var stepPx = "".concat(3 * radius, "px");
  var frames = 12; // 3 circles * 4 steps each

  var percantagePerFrame = 100 / frames;
  var duration = 3; // sec

  /*
    circle diameter + space between circles + circle diameter
      (2 * radius)  +        radius         +   (2 * radius)
  */

  var svgSize = 5 * radius;
  var start = {
    transform: "translate3d(0, 0, 0)"
  };
  var right = {
    transform: "translate3d(".concat(stepPx, ", 0, 0)")
  };
  var bottom = {
    transform: "translate3d(0, ".concat(stepPx, ", 0)")
  };
  var left = {
    transform: "translate3d(-".concat(stepPx, ", 0, 0)")
  };
  var up = {
    transform: "translate3d(0, -".concat(stepPx, ", 0)")
  };
  var rightAndBottom = {
    transform: "translate3d(".concat(stepPx, ", ").concat(stepPx, ", 0)")
  };
  var upAndRight = {
    transform: "translate3d(".concat(stepPx, ", -").concat(stepPx, ", 0)")
  };
  var leftAndUp = {
    transform: "translate3d(-".concat(stepPx, ", -").concat(stepPx, ", 0)")
  };

  var getKeyframes = function getKeyframes(steps) {
    return keyframes(steps.reduce(function (acc, step, index) {
      acc["".concat(index * percantagePerFrame, "%")] = step;
      return acc;
    }, {}));
  };

  var svgCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(_ref, theme) {
      var _theme$getColor;

      var _color = _ref.color;
      return {
        fill: (_theme$getColor = theme.getColor(_color)) !== null && _theme$getColor !== void 0 ? _theme$getColor : theme.colors.black
      };
    }
  });
  var circleCSS = [getKeyframes([start, right, right, right, rightAndBottom, rightAndBottom, rightAndBottom, bottom, bottom, bottom, start, start]), getKeyframes([start, start, up, up, up, upAndRight, upAndRight, upAndRight, right, right, right, start]), getKeyframes([start, start, start, left, left, left, leftAndUp, leftAndUp, leftAndUp, up, up, up])].map(function (animation) {
    return {
      animation: "".concat(animation, " ").concat(duration, "s ease infinite")
    };
  });
  return ___EmotionJSX("svg", {
    css: svgCSS,
    width: svgSize,
    height: svgSize,
    viewBox: "0 0 ".concat(svgSize, " ").concat(svgSize),
    focusable: "false",
    role: "img",
    "aria-label": "Loading icon",
    "data-testid": testId
  }, ___EmotionJSX("circle", {
    cx: radius,
    cy: radius,
    r: radius,
    css: circleCSS[0]
  }), ___EmotionJSX("circle", {
    cx: radius,
    cy: 4 * radius,
    r: radius,
    css: circleCSS[1]
  }), ___EmotionJSX("circle", {
    cx: 4 * radius,
    cy: 4 * radius,
    r: radius,
    css: circleCSS[2]
  }));
}

LoadingIcon.propTypes = _objectSpread(_objectSpread({}, responsivePropType("color", PropTypes.oneOf(COLORS))), {}, {
  size: PropTypes.oneOf(SIZES),
  testId: PropTypes.string
});
export default LoadingIcon;